import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const truckRouter: Array<RouteConfig> = [
  {
    path: "trucks_list",
    name: "trucks_list",
    component: () => import("@/views/Truck/TruckList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "trucks_list/:id",
    name: "truckId",
    component: () => import("@/views/Truck/Truck.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "trucks_list/new_truck",
    name: "new_truck",
    component: () => import("@/views/Truck/NewTruck.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "galery_list",
    name: "galery_list",
    component: () => import("@/views/Truck/GaleryList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  }
];

export default truckRouter;
